import React, { Component } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Typography,
} from "@mui/material";
import Form from "react-bootstrap/Form";
import { searchService } from "../../service/question/searchService.js";
import { CardHeader, Spinner } from "react-bootstrap";
import { sweetStatusAlert } from "../../components/common/SweetAlert.js";
import ContentWrapper from "../../components/common/ContentWrapper.js";
import config from "../../helper/config.js";
import { customerConstants } from "../../helper/constants.js";
import MaterialCustomTablePagination from "../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import PageSpinner from "../../components/common/spinner/PageSpinner.js";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import { Box, Chip, CircularProgress, IconButton } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FormControlLabel from "@mui/material/FormControlLabel";
import PaperListChips from "../manage/paper/edsider/FindPaperTabs/PaperListChips.js";
import Checkbox from "@mui/material/Checkbox";
import { QUESTION_SEARCH_FILTERS } from "../../helper/constants";
import Card from "../../components/common/Card.js";
import AdminTemplate from "../../components/admin/layouts/Template.js";
import CardBody from "../../components/common/CardBody.js";
import ClearIcon from "@mui/icons-material/Clear";
import Tooltip from "@mui/material/Tooltip";
import QuestionStatModal from "./QuestionStatModal.js";
import BarChartIcon from "@mui/icons-material/BarChart";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { styled } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { tableCellClasses } from "@mui/material/TableCell";
import ChevronLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import PaperFilterLayout from "../manage/paper/edsider/TheFilter/PaperFilterLayout.js";
import { EMPLOYEE_FILTERS } from "../../helper/constants.js";
import StickyCardBody from "../../components/common/StickyCardBody.js";
import { CardContent } from "semantic-ui-react";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2A237C", // Purple-blue color
    color: theme.palette.common.white,
    fontSize: 14,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
  },
}));

class QuestionSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTableDataLoading: false,
      isSpinnerLoading: false,
      summary_data_month: [],
      summary_data_week: [],
      summary_data_daily: [],
      summary_data_person_month: [],
      summary_data_person_week: [],
      summary_data_person: [],
      allSubjects: [],
      allLanguages: [],
      allCreators: [],
      limit: 50,
      offset: 0,
      search_term: "",
      sort_column: "created_at",
      sort_direction: "ASC",
      currentPage: 0,
      rowsPerPage: 50,
      total_summary_data_month: 0,
      total_summary_data_week: 0,
      total_summary_data_daily: 0,
      total_summary_data_person_month: 0,
      total_summary_data_person_week: 0,
      total_summary_data_person_daily: 0,
      total_sum_data_month: 0,
      total_sum_data_week: 0,
      total_sum_data_daily: 0,
      total_sum_data_person_month: 0,
      total_sum_data_person_week: 0,
      total_sum_data_person_daily: 0,
      total_sum_data_person: 0,
      currentPage: 0,
      editVisibility: true,
      addVisibility: true,
      deleteVisibility: true,
      selectedGrades: null,
      selectedSubjects: null,
      selectedLanguages: null,
      selectedCreators: null,
      selectedStartDate: null,
      selectedEndDate: null,
      selectedMonth: null,
      selectedMonthName: "",
      selectedWeek: null,
      selectedWeekName: "",
      availableWeeks: [],
      filterValues: [],
      filters: [],
      disabled: false,
      isChartModalOpen: false,
    };
    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(
      this.fetchAllQuestionsStatistics,
      2000
    );
  }

  componentDidMount() {
    this.fetchAllMetaData();
    this.fetchAllQuestionsStatistics();
  }

  fetchAllMetaData = async () => {
    this.setState({
      isTableDataLoading: true,
    });

    const fetchMetaData =
      await searchService.getAllMetaDataForQuestionSummary();

    await Promise.all([fetchMetaData])
      .then((response) => {
        const [metaDataResponse] = response;

        this.setState({
          allGrades: metaDataResponse.data.find((item) => "grades" in item)
            .grades,
          allSubjects: metaDataResponse.data.find((item) => "subjects" in item)
            .subjects,
          allLanguages: metaDataResponse.data.find(
            (item) => "languages" in item
          ).languages,
          allCreators: metaDataResponse.data.find((item) => "creators" in item)
            .creators,
          isSpinnerLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          isSpinnerLoading: false,
        });
      });
  };

  fetchAllQuestionsStatistics = async () => {
    this.setState({
      isTableDataLoading: true,
    });
    const {
      limit,
      offset,
      sort_column,
      sort_direction,
      search_term,
      selectedGrades,
      selectedSubjects,
      selectedLanguages,
      selectedCreators,
      selectedStartDate,
      selectedEndDate,
      selectedMonth,
      selectedWeek,
    } = this.state;

    const fetchSummaryData =
      await searchService.getAllQuestionSummaryMonthlyByLanguageSubject(
        limit,
        offset,
        sort_column,
        sort_direction,
        search_term,
        selectedGrades ? `{${selectedGrades}}` : null,
        selectedSubjects ? `{${selectedSubjects}}` : null,
        selectedLanguages ? `{${selectedLanguages}}` : null,
        selectedCreators ? `{${selectedCreators}}` : null,
        selectedStartDate,
        selectedEndDate,
        selectedMonth,
        selectedWeek
      );

    await Promise.all([fetchSummaryData])
      .then((response) => {
        const [summaryDataResponse] = response;

        this.setState({
          summary_data_month: summaryDataResponse.data.summary_data.find(
            (item) => "month_summary" in item
          ).month_summary,
          total_summary_data_month: summaryDataResponse.data.summary_data.find(
            (item) => "month_summary" in item
          ).total_month_summary_count,
          total_sum_data_month: summaryDataResponse.data.summary_data.find(
            (item) => "month_summary" in item
          ).total_month_sum_count,
          summary_data_week: summaryDataResponse.data.summary_data.find(
            (item) => "week_summary" in item
          ).week_summary,
          total_summary_data_week: summaryDataResponse.data.summary_data.find(
            (item) => "week_summary" in item
          ).total_week_summary_count,
          total_sum_data_week: summaryDataResponse.data.summary_data.find(
            (item) => "week_summary" in item
          ).total_week_sum_count,
          summary_data_daily: summaryDataResponse.data.summary_data.find(
            (item) => "daily_summary" in item
          ).daily_summary,
          total_summary_data_daily: summaryDataResponse.data.summary_data.find(
            (item) => "daily_summary" in item
          ).total_daily_summary_count,
          total_sum_data_daily: summaryDataResponse.data.summary_data.find(
            (item) => "daily_summary" in item
          ).total_daily_sum_count,
          summary_data_person_month: summaryDataResponse.data.summary_data.find(
            (item) => "person_month_summary" in item
          ).person_month_summary,
          total_summary_data_person_month:
            summaryDataResponse.data.summary_data.find(
              (item) => "person_month_summary" in item
            ).total_person_month_summary_count,
          total_sum_data_person_month:
            summaryDataResponse.data.summary_data.find(
              (item) => "person_month_summary" in item
            ).total_person_month_sum_count,
          summary_data_person_week: summaryDataResponse.data.summary_data.find(
            (item) => "person_week_summary" in item
          ).person_week_summary,
          total_summary_data_person_week:
            summaryDataResponse.data.summary_data.find(
              (item) => "person_week_summary" in item
            ).total_person_week_summary_count,
          total_sum_data_person_week:
            summaryDataResponse.data.summary_data.find(
              (item) => "person_week_summary" in item
            ).total_person_week_sum_count,
          summary_data_person: summaryDataResponse.data.summary_data.find(
            (item) => "person_summary" in item
          ).person_summary,
          total_summary_data_person: summaryDataResponse.data.summary_data.find(
            (item) => "person_summary" in item
          ).total_person_summary_count,
          total_sum_data_person: summaryDataResponse.data.summary_data.find(
            (item) => "person_summary" in item
          ).total_person_sum_count,
          isTableDataLoading: false,
        });
      })
      .catch((error) => {
        sweetStatusAlert(
          "Failed!",
          "Error fetching Question statistics. Please refresh the screen!",
          "error"
        );
        this.setState({
          isSpinnerLoading: false,
        });
      });
  };

  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllQuestionsStatistics();
      }
    );
  };

  handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
      currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
      {
        sort_column,
        sort_direction: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
        this.fetchAllQuestionsStatistics();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllQuestionsStatistics();
      }
    );
  };

  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllQuestionsStatistics();
      }
    );
  };

  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  onSelectFilterMulti = (selectedItem) => {
    const { filterValues } = this.state;

    let updatedFilterValues = [...filterValues];

    const index = updatedFilterValues.findIndex(
      (item) =>
        item.filter === selectedItem.filter &&
        item[`${selectedItem.filter.toLowerCase()}_id`] ===
          selectedItem[`${selectedItem.filter.toLowerCase()}_id`]
    );

    if (index === -1) {
      updatedFilterValues.push(selectedItem);
    } else {
      updatedFilterValues.splice(index, 1);
    }

    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  onSelectFilterMultiProcess = (filterValues) => {
    const filterMap = {
      Grade: [],
      Subject: [],
      Language: [],
      Created_By: [],
    };

    filterValues.forEach((val) => {
      const filterType = val.filter;
      if (filterType && filterMap.hasOwnProperty(filterType)) {
        switch (filterType) {
          case "Created_By":
            filterMap.Created_By.push(val?.created_by_id);
            break;
          case "Grade":
            filterMap.Grade.push(val?.grade_id);
            break;
          case "Language":
            filterMap.Language.push(val?.language_id);
            break;
          case "Subject":
            filterMap.Subject.push(val?.subject_id);
            break;
          default:
            break;
        }
      }
    });

    this.setState(
      {
        filterValues,
        selectedSubjects:
          filterMap.Subject.length > 0 ? filterMap.Subject : null,
        selectedLanguages:
          filterMap.Language.length > 0 ? filterMap.Language : null,
        selectedGrades: filterMap.Grade.length > 0 ? filterMap.Grade : null,
        selectedCreators:
          filterMap.Created_By.length > 0 ? filterMap.Created_By : null,
      },
      () => {
        this.fetchAllQuestionsStatistics();
      }
    );
  };

  isParentChecked = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    return (
      childItems.length > 0 &&
      childItems.every((child) =>
        filterValues.some(
          (selectedItem) =>
            selectedItem.filter === filterType &&
            selectedItem[`${filterType.toLowerCase()}_id`] ===
              child[`${filterType.toLowerCase()}_id`]
        )
      )
    );
  };

  isParentIndeterminate = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    const selectedCount = childItems.filter((child) =>
      filterValues.some(
        (selectedItem) =>
          selectedItem.filter === filterType &&
          selectedItem[`${filterType.toLowerCase()}_id`] ===
            child[`${filterType.toLowerCase()}_id`]
      )
    ).length;
    return selectedCount > 0 && selectedCount < childItems.length;
  };

  handleParentCheckboxChange = (filterType, filterItems) => {
    const filterValues = [...this.state.filterValues];
    const childItems = filterItems;

    const allSelected = this.isParentChecked(filterType);

    let updatedFilterValues;
    if (allSelected) {
      updatedFilterValues = filterValues.filter(
        (item) => item.filter !== filterType
      );
    } else {
      const newSelections = childItems.map((child) => ({
        filter: filterType,
        name: child.name,
        [`${filterType.toLowerCase()}_id`]:
          child[`${filterType.toLowerCase()}_id`],
      }));
      updatedFilterValues = [
        ...filterValues.filter((item) => item.filter !== filterType),
        ...newSelections,
      ];
    }

    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  getChildItems = (filterType) => {
    switch (filterType) {
      case "Created_By":
        return this.state.allCreators || [];
      case "Grade":
        return this.state.allGrades || [];
      case "Language":
        return this.state.allLanguages || [];
      case "Subject":
        return this.state.allSubjects || [];
      default:
        return [];
    }
  };

  clearAllFilters = () => {
    this.setState(
      {
        filterValues: [],
        selectedSubjects: null,
        selectedLanguages: null,
        selectedGrades: null,
        selectedCreators: null,
      },
      () => {
        this.fetchAllQuestionsStatistics();
      }
    );
  };

  handleStartDateChange = (event) => {
    const date = event.target.value;
    const formattedDate = date ? date.replace(/-/g, "") : null;
    this.setState({ selectedStartDate: formattedDate }, () => {
      this.fetchAllQuestionsStatistics();
    });
  };

  handleEndDateChange = (event) => {
    const date = event.target.value;
    const formattedDate = date ? date.replace(/-/g, "") : null;
    this.setState({ selectedEndDate: formattedDate }, () => {
      this.fetchAllQuestionsStatistics();
    });
  };

  handleFilterChange = (newSelectedFilters) => {
    const getOrNull = (key) =>
      newSelectedFilters[key] && newSelectedFilters[key].length > 0
        ? newSelectedFilters[key]
        : null;

    this.setState(
      {
        selectedGrades: getOrNull("Grade"),
        selectedsubjects: getOrNull("Subject"),
        selectedLanguages: getOrNull("Language"),
        selectedCreators: getOrNull("Created_By"),
        selectedStartDate: getOrNull("StartDate"),
        selectedEndDate: getOrNull("EndDate"),
        selectedStartDate: getOrNull("StartDate"),
        selectedEndDate: getOrNull("EndDate"),

        offset: 0,
        currentPage: 0,
      },
      () => {
        this.fetchAllQuestionsStatistics();
      }
    );
  };

  getAvailableMonths() {
    if (this.state.selectedStartDate && this.state.selectedEndDate) {
      const startDateString = this.state.selectedStartDate.replace(
        /(\d{4})(\d{2})(\d{2})/,
        "$1-$2-$3"
      );
      const endDateString = this.state.selectedEndDate.replace(
        /(\d{4})(\d{2})(\d{2})/,
        "$1-$2-$3"
      );

      const startDate = new Date(startDateString);
      const endDate = new Date(endDateString);

      const months = [];

      let currentMonth = startDate.getMonth();
      let currentYear = startDate.getFullYear();

      while (
        currentYear < endDate.getFullYear() ||
        (currentYear === endDate.getFullYear() &&
          currentMonth <= endDate.getMonth())
      ) {
        const monthYear =
          new Date(currentYear, currentMonth).toLocaleString("default", {
            month: "short",
          }) +
          " " +
          currentYear;
        months.push(monthYear);

        currentMonth++;
        if (currentMonth > 11) {
          currentMonth = 0;
          currentYear++;
        }
      }

      return months;
    }
    return [];
  }

  getAvailableWeeks = (year, month) => {
    if (!this.state.selectedStartDate || !this.state.selectedEndDate) {
      console.warn("Start or end date is not selected.");
      return [];
    }

    const startDateString = this.state.selectedStartDate.replace(
      /(\d{4})(\d{2})(\d{2})/,
      "$1-$2-$3"
    );
    const endDateString = this.state.selectedEndDate.replace(
      /(\d{4})(\d{2})(\d{2})/,
      "$1-$2-$3"
    );

    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    const firstDayOfMonth = new Date(year, month - 1, 1);
    const lastDayOfMonth = new Date(year, month, 0);

    const validStart =
      startDate > firstDayOfMonth ? startDate : firstDayOfMonth;
    const validEnd = endDate < lastDayOfMonth ? endDate : lastDayOfMonth;

    const weeks = [];
    let currentDay = new Date(validStart);

    while (currentDay <= validEnd) {
      const weekNumber = this.getISOWeekNumber(currentDay);
      if (!weeks.includes(weekNumber)) {
        weeks.push(weekNumber);
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }

    return weeks.map((week, index) => `Week ${index + 1}`);
  };

  getISOWeekNumber = (date) => {
    let tempDate = new Date(date);
    tempDate.setHours(0, 0, 0, 0);

    tempDate.setDate(tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7));

    let firstThursday = new Date(tempDate.getFullYear(), 0, 4);
    firstThursday.setDate(
      firstThursday.getDate() + 3 - ((firstThursday.getDay() + 6) % 7)
    );

    let weekNumber = Math.round(
      (tempDate - firstThursday) / (7 * 24 * 60 * 60 * 1000) + 1
    );
    return weekNumber;
  };

  handleSelectedMonthChange = (event) => {
    const selectedMonthName = event.target.value;

    if (!selectedMonthName) {
      console.warn("No month selected.");
      return;
    }

    this.setState({ selectedMonthName: selectedMonthName });

    const [monthAbbrev, selectedYear] = selectedMonthName.split(" ");

    if (!selectedYear || !monthAbbrev) {
      console.warn("Invalid month format:", selectedMonthName);
      return;
    }

    const monthsMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      Jun: 6,
      Jul: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };

    const selectedMonthNumber = monthsMap[monthAbbrev];

    if (!selectedMonthNumber) {
      console.warn("Invalid month abbreviation:", monthAbbrev);
      return;
    }

    const formattedMonthYear = `${selectedYear}${selectedMonthNumber
      .toString()
      .padStart(2, "0")}`;

    this.setState({ selectedMonth: formattedMonthYear }, () => {
      const availableWeeks = this.getAvailableWeeks(
        selectedYear,
        selectedMonthNumber
      );
      this.setState({ availableWeeks });
      this.fetchAllQuestionsStatistics();
    });
  };

  handleSelectedWeekChange = (event) => {
    const selectedWeekName = event.target.value;

    if (!selectedWeekName) {
      console.warn("No week selected.");
      return;
    }

    this.setState({ selectedWeekName });

    const weekNumber = parseInt(selectedWeekName.replace("Week ", ""), 10);

    if (isNaN(weekNumber)) {
      console.warn("Invalid week format:", selectedWeekName);
      return;
    }

    const { selectedMonth } = this.state;
    if (!selectedMonth) return;

    const year = parseInt(selectedMonth.substring(0, 4), 10);
    const month = parseInt(selectedMonth.substring(4, 6), 10) - 1;

    const firstDayOfMonth = new Date(year, month, 1);
    const firstWeekOfMonth = this.getISOWeekNumber(firstDayOfMonth);

    const actualWeekNumber = firstWeekOfMonth + weekNumber - 1;

    this.setState(
      {
        selectedWeek: actualWeekNumber,
      },
      () => {
        this.fetchAllQuestionsStatistics();
      }
    );
  };

  clearDateRange = () => {
    this.setState(
      {
        selectedStartDate: "",
        selectedEndDate: "",
        selectedMonth: "",
        selectedWeek: "",
      },
      () => {
        this.setState(
          {
            selectedStartDate: null,
            selectedEndDate: null,
            selectedMonth: null,
            selectedWeek: null,
          },
          () => {
            this.fetchAllQuestionsStatistics();
          }
        );
      }
    );
  };

  handleChartOpen = () => {
    this.setState({ isChartModalOpen: true });
  };

  handleChartClose = () => {
    this.setState({ isChartModalOpen: false });
  };

  render() {
    const {
      limit,
      summary_data_month,
      summary_data_week,
      summary_data_daily,
      summary_data_person_month,
      summary_data_person_week,
      summary_data_person,
      total_summary_data_month,
      total_summary_data_week,
      total_summary_data_daily,
      total_summary_data_person_month,
      total_summary_data_person_week,
      total_summary_data_person,
      total_sum_data_month,
      total_sum_data_week,
      total_sum_data_daily,
      total_sum_data_person_month,
      total_sum_data_person_week,
      total_sum_data_person,
      isTableDataLoading,
      currentPage,
      isSpinnerLoading,
    } = this.state;
    return (
      <AdminTemplate>
        <ContentWrapper>
          <Card>
			<CardHeader>
				<div className="row justify-content-between align-items-center py-5 mb-3">
                  <div className="col-md-6 col-6">
                    <h3 className="text-nowrap">Manage Question Statistics</h3>
                  </div>
                </div>
			</CardHeader>
            <CardBody>

			 <div className="col-md-8 px-0 mb-3">
                          <div className="row align-items-center mb-4">

                            <div className="col-md-4 mb-2 mb-md-0">
                              <Form.Group
                                controlId="exampleForm.ControlInput1"
                                className="mb-0 w-100"
                                style={{ maxWidth: "300px" }}
                              >
                                <Form.Control
                                  type="text"
                                  placeholder="Search"
                                  onChange={this.handleSearch}
                                  isInvalid={this.state.searchError}
                                />
                                {this.state.searchError && (
                                  <Form.Control.Feedback type="invalid">
                                    Invalid input
                                  </Form.Control.Feedback>
                                )}
                              </Form.Group>
                            </div>

                            <div className="col-md-3 mb-2 mb-md-0 d-flex justify-content-center">
                              <span
                                className="badge badge-custom"
                                style={{ fontSize: "1rem" }}
                              >
                                Total Questions:{" "}
                                <strong>
                                  {this.state.isTableDataLoading ? (
                                    <CircularProgress size={16} />
                                  ) : (
                                    total_sum_data_daily
                                  )}
                                </strong>
                              </span>
                            </div>

                          </div>
			 </div>
              <>
                <div className="thepapers-wrapper">
                  <div className="col-md-12 px-0">
                    <div className="row mt-6">

                      <div
                        className={`${
                          this.state.isFilterCollapsed ? "col-md-1" : "col-md-3"
                        } px-0 transition-width`}
                      >
                        <div className="filter-container">
                          <div
                            className={`${
                              this.state.isFilterCollapsed
                                ? "collapsed-filter"
                                : "expanded-filter"
                            } filter-dynamic`}
                          >
                            <div className="d-flex flex-column flex-md-row flex-wrap align-items-stretch align-items-md-center justify-content-between w-100 gap-2">
                              {/* Filters label shows when collapsed */}
                              <span
                                className={`${
                                  this.state.isFilterCollapsed
                                    ? "d-block"
                                    : "d-none"
                                } filter-title`}
                              >
                                Filters
                              </span>
                              <IconButton
                                onClick={() =>
                                  this.setState((prev) => ({
                                    ...prev,
                                    isFilterCollapsed: !prev.isFilterCollapsed,
                                  }))
                                }
                              >
                                {this.state.isFilterCollapsed ? (
                                  <ChevronRightIcon />
                                ) : (
                                  <ChevronLeftIcon />
                                )}
                              </IconButton>
                            </div>
                          </div>

                          {/* PaperFilterLayout goes here  */}
                          <div className="col-md-12 px-0 filterBySec"style={{display: this.state.isFilterCollapsed ? "none" : "block" }}>
                            <div className="col-md-12 px-0 filterBySec ">
                              <PaperFilterLayout
                                userType={"MASAD"}
                                onFilterChange={this.handleFilterChange}
                                filterKeys={
                                  EMPLOYEE_FILTERS.MASAD.QuestionSearch
                                }
                                isShowExamStatus={false}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={`${
                          this.state.isFilterCollapsed
                            ? "col-md-11"
                            : "col-md-9"
                        } transition-width`}
                      >

						
                    		  	
                        <div>
                          {isTableDataLoading ? (
                            <div
                              className="loading-container"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "75vw",
                                height: "90vh",
                              }}
                            >
                              <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                              </Spinner>
                            </div>
                          ) : summary_data_daily.length > 0 ? (
                            <TableContainer
                              component={Paper}
                              sx={{
                                width: "100%",
                                maxHeight: "90vh",
                                mb: 3,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  p: 2,
                                  backgroundColor: "#f5f5f5",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 2,
                                }}
                              >
                                Summary by grade, subject, language daily with
                                person
                              </Typography>
                              <Box sx={{ overflow: "auto", flex: 1 }}>
                                <Table
                                  stickyHeader
                                  aria-label="customized table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("month")
                                        }
                                      >
                                        Date{" "}
                                        {this.state.sort_column ===
                                          "created_date" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("language_id")
                                        }
                                      >
                                        Grade{" "}
                                        {this.state.sort_column === "grade" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("language_id")
                                        }
                                      >
                                        Subject{" "}
                                        {this.state.sort_column ===
                                          "subject" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("subject_id")
                                        }
                                      >
                                        Language{" "}
                                        {this.state.sort_column ===
                                          "language" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("subject_id")
                                        }
                                      >
                                        Created By{" "}
                                        {this.state.sort_column ===
                                          "last_name" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("subject_id")
                                        }
                                      >
                                        Total Questions{" "}
                                        {this.state.sort_column ===
                                          "total_questions" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {summary_data_daily.map((recordItem) => (
                                      <StyledTableRow key={recordItem.month}>
                                        <StyledTableCell>
                                          {recordItem.created_date}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.grade
                                            ? recordItem.grade
                                            : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.subject
                                            ? recordItem.subject
                                            : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.language
                                            ? recordItem.language
                                            : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.first_name +
                                            " " +
                                            recordItem.last_name}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.total_questions}
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </Box>
                              <Box
                                sx={{
                                  p: 2,
                                  position: "sticky",
                                  bottom: 0,
                                  backgroundColor: "white",
                                  borderTop: "1px solid rgba(224, 224, 224, 1)",
                                  zIndex: 2,
                                }}
                              >
                                <MaterialCustomTablePagination
                                  totalCount={total_summary_data_daily}
                                  currentPage={currentPage}
                                  limit={limit}
                                  handlePageChange={this.handlePageChange}
                                  handleRowsPerPageChange={
                                    this.handleRowsPerPageChange
                                  }
                                  handlePageOffsetChange={
                                    this.handlePageOffsetChange
                                  }
                                  offset={this.state.offset}
                                  rowsPerPageOptions={[
                                    5, 10, 25, 50, 100, 200, 300,
                                  ]}
                                />
                              </Box>
                            </TableContainer>
                          ) : (
                            <div
                              className="text-center mb-5 mt-10"
                              style={{ height: "90vh" }}
                            >
                              <label>No Data Available!</label>
                            </div>
                          )}
                          {isTableDataLoading ? (
                            <div
                              className="loading-container"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "75vw",
                                height: "90vh",
                              }}
                            >
                              <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                              </Spinner>
                            </div>
                          ) : summary_data_month.length > 0 ? (
                            <TableContainer
                              component={Paper}
                              sx={{
                                width: "100%",
                                maxHeight: "90vh",
                                mb: 3,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  p: 2,
                                  backgroundColor: "#f5f5f5",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 2,
                                }}
                              >
                                Summary by grade, subject, language monthly
                              </Typography>
                              <Box sx={{ overflow: "auto", flex: 1 }}>
                                <Table
                                  stickyHeader
                                  aria-label="customized table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("month")
                                        }
                                      >
                                        Month{" "}
                                        {this.state.sort_column === "month" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("grade_id")
                                        }
                                      >
                                        Year{" "}
                                        {this.state.sort_column === "year" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("language_id")
                                        }
                                      >
                                        Grade{" "}
                                        {this.state.sort_column === "grade" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("language_id")
                                        }
                                      >
                                        Subject{" "}
                                        {this.state.sort_column ===
                                          "subject" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("subject_id")
                                        }
                                      >
                                        Language{" "}
                                        {this.state.sort_column ===
                                          "language" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("subject_id")
                                        }
                                      >
                                        Total Questions{" "}
                                        {this.state.sort_column ===
                                          "total_questions" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {summary_data_month.map((recordItem) => (
                                      <StyledTableRow key={recordItem.month}>
                                        <StyledTableCell>
                                          {recordItem.month}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.year}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.grade
                                            ? recordItem.grade
                                            : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.subject
                                            ? recordItem.subject
                                            : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.language
                                            ? recordItem.language
                                            : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.total_questions}
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </Box>
                              <Box
                                sx={{
                                  p: 2,
                                  position: "sticky",
                                  bottom: 0,
                                  backgroundColor: "white",
                                  borderTop: "1px solid rgba(224, 224, 224, 1)",
                                  zIndex: 2,
                                }}
                              >
                                <MaterialCustomTablePagination
                                  totalCount={total_summary_data_month}
                                  currentPage={currentPage}
                                  limit={limit}
                                  handlePageChange={this.handlePageChange}
                                  handleRowsPerPageChange={
                                    this.handleRowsPerPageChange
                                  }
                                  handlePageOffsetChange={
                                    this.handlePageOffsetChange
                                  }
                                  offset={this.state.offset}
                                  rowsPerPageOptions={[
                                    5, 10, 25, 50, 100, 200, 300,
                                  ]}
                                />
                              </Box>
                            </TableContainer>
                          ) : (
                            <div
                              className="text-center mb-5 mt-10"
                              style={{ height: "90vh" }}
                            >
                              <label>No Data Available!</label>
                            </div>
                          )}
                          {isTableDataLoading ? (
                            <div
                              className="loading-container"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "75vw",
                                height: "90vh",
                              }}
                            >
                              <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                              </Spinner>
                            </div>
                          ) : summary_data_person_month.length > 0 ? (
                            <TableContainer
                              component={Paper}
                              sx={{
                                width: "100%",
                                maxHeight: "90vh",
                                mb: 3,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  p: 2,
                                  backgroundColor: "#f5f5f5",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 2,
                                }}
                              >
                                Summary by person monthly
                              </Typography>
                              <Box sx={{ overflow: "auto", flex: 1 }}>
                                <Table
                                  stickyHeader
                                  aria-label="customized table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("month")
                                        }
                                      >
                                        Month{" "}
                                        {this.state.sort_column === "month" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("grade_id")
                                        }
                                      >
                                        Year{" "}
                                        {this.state.sort_column === "year" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("language_id")
                                        }
                                      >
                                        First Name{" "}
                                        {this.state.sort_column ===
                                          "first_name" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("language_id")
                                        }
                                      >
                                        Last Name{" "}
                                        {this.state.sort_column ===
                                          "last_name" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("subject_id")
                                        }
                                      >
                                        Total Questions{" "}
                                        {this.state.sort_column ===
                                          "total_questions" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {summary_data_person_month.map(
                                      (recordItem) => (
                                        <StyledTableRow key={recordItem.month}>
                                          <StyledTableCell>
                                            {recordItem.month}
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            {recordItem.year}
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            {recordItem.first_name}
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            {recordItem.last_name}
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            {recordItem.total_questions}
                                          </StyledTableCell>
                                        </StyledTableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </Box>
                              <Box
                                sx={{
                                  p: 2,
                                  position: "sticky",
                                  bottom: 0,
                                  backgroundColor: "white",
                                  borderTop: "1px solid rgba(224, 224, 224, 1)",
                                  zIndex: 2,
                                }}
                              >
                                <MaterialCustomTablePagination
                                  totalCount={total_summary_data_person_month}
                                  currentPage={currentPage}
                                  limit={limit}
                                  handlePageChange={this.handlePageChange}
                                  handleRowsPerPageChange={
                                    this.handleRowsPerPageChange
                                  }
                                  handlePageOffsetChange={
                                    this.handlePageOffsetChange
                                  }
                                  offset={this.state.offset}
                                  rowsPerPageOptions={[
                                    5, 10, 25, 50, 100, 200, 300,
                                  ]}
                                />
                              </Box>
                            </TableContainer>
                          ) : (
                            <div
                              className="text-center mb-5 mt-10"
                              style={{ height: "90vh" }}
                            >
                              <label>No Data Available!</label>
                            </div>
                          )}
                          {isTableDataLoading ? (
                            <div
                              className="loading-container"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "75vw",
                                height: "90vh",
                              }}
                            >
                              <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                              </Spinner>
                            </div>
                          ) : summary_data_person.length > 0 ? (
                            <TableContainer
                              component={Paper}
                              sx={{
                                width: "100%",
                                maxHeight: "90vh",
                                mb: 3,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight: "bold",
                                  p: 2,
                                  backgroundColor: "#f5f5f5",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 2,
                                }}
                              >
                                Summary by person (grade, subject, language)
                              </Typography>
                              <Box sx={{ overflow: "auto", flex: 1 }}>
                                <Table
                                  stickyHeader
                                  aria-label="customized table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("month")
                                        }
                                      >
                                        First Name{" "}
                                        {this.state.sort_column ===
                                          "first_name" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("grade_id")
                                        }
                                      >
                                        Last Name{" "}
                                        {this.state.sort_column ===
                                          "last_name" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("language_id")
                                        }
                                      >
                                        Grade{" "}
                                        {this.state.sort_column === "grade" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("language_id")
                                        }
                                      >
                                        Subject{" "}
                                        {this.state.sort_column ===
                                          "subject" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("subject_id")
                                        }
                                      >
                                        Language{" "}
                                        {this.state.sort_column ===
                                          "language" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{
                                                  fontSize: 15,
                                                  color: "white",
                                                }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.handleSortChange("subject_id")
                                        }
                                      >
                                        Total Questions{" "}
                                        {this.state.sort_column ===
                                          "total_questions" && (
                                          <span>
                                            {this.state.sort_direction ===
                                            "ASC" ? (
                                              <ArrowDownwardIcon
                                                sx={{ fontSize: 15 }}
                                              />
                                            ) : (
                                              <ArrowUpwardIcon
                                                sx={{ fontSize: 15 }}
                                              />
                                            )}
                                          </span>
                                        )}
                                      </StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {summary_data_person.map((recordItem) => (
                                      <StyledTableRow
                                        key={recordItem.created_by}
                                      >
                                        <StyledTableCell>
                                          {recordItem.first_name}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.last_name}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.grade
                                            ? recordItem.grade
                                            : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.subject
                                            ? recordItem.subject
                                            : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.language
                                            ? recordItem.language
                                            : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                          {recordItem.total_questions}
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </Box>
                              <Box
                                sx={{
                                  p: 2,
                                  position: "sticky",
                                  bottom: 0,
                                  backgroundColor: "white",
                                  borderTop: "1px solid rgba(224, 224, 224, 1)",
                                  zIndex: 2,
                                }}
                              >
                                <MaterialCustomTablePagination
                                  totalCount={total_summary_data_person}
                                  currentPage={currentPage}
                                  limit={limit}
                                  handlePageChange={this.handlePageChange}
                                  handleRowsPerPageChange={
                                    this.handleRowsPerPageChange
                                  }
                                  handlePageOffsetChange={
                                    this.handlePageOffsetChange
                                  }
                                  offset={this.state.offset}
                                  rowsPerPageOptions={[
                                    5, 10, 25, 50, 100, 200, 300,
                                  ]}
                                />
                              </Box>
                            </TableContainer>
                          ) : (
                            <div
                              className="text-center mb-5 mt-10"
                              style={{ height: "90vh" }}
                            >
                              <label>No Data Available!</label>
                            </div>
                          )}
                        </div> 

						<>

                          {/*
																				{isTableDataLoading ? (
																					<div
																						className="loading-container"
																						style={{
																							display: "flex",
																							alignItems: "center",
																							justifyContent: "center",
																							width: "75vw",
																							height: "90vh",
																						}}
																					>
																						<Spinner animation="border" role="status">
																							<span className="sr-only">Loading...</span>
																						</Spinner>
																					</div>
																				) : (summary_data_week.length > 0 ? (
																				<div style={{ width: "80vw", height: "90vh", overflow: "auto" }}>
																					<Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 2 }}>
																						Summary by grade,subject,language weekly
																					</Typography>
																					<Table>
																					<TableHead>
																						<TableRow>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("month")}
																						>
																							Month{" "}
																							{this.state.sort_column === "month" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("grade_id")}
																						>
																							Year{" "}
																							{this.state.sort_column === "year" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("grade_id")}
																						>
																							Week{" "}
																							{this.state.sort_column === "week" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("language_id")}
																						>
																							Grade{" "}
																							{this.state.sort_column === "grade" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("language_id")}
																						>
																							Subject{" "}
																							{this.state.sort_column === "subject" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("subject_id")}
																						>
																							Language{" "}
																							{this.state.sort_column === "language" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("subject_id")}
																						>
																							Total Questions{" "}
																							{this.state.sort_column === "total_questions" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						</TableRow>
																					</TableHead>

																					<TableBody>
																						{summary_data_week.map((recordItem) => (
																						<TableRow key={recordItem.month}>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.month}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.year}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.week}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.grade ? recordItem.grade :  'N/A'}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.subject ? recordItem.subject :  'N/A'}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.language ? recordItem.language:  'N/A'}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.total_questions}
																							</TableCell>
																						</TableRow>
																						))}
																					</TableBody>
																					</Table>
																					<MaterialCustomTablePagination
																						totalCount = {total_summary_data_week}
																						currentPage = {currentPage}
																						limit = {limit}
																						handlePageChange = {this.handlePageChange}
																						handleRowsPerPageChange = {this.handleRowsPerPageChange}
																						handlePageOffsetChange = {this.handlePageOffsetChange}
																						offset = {this.state.offset}
																						rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 300]}
																					/>
																				</div>
																				) : (
																				<div
																					className="text-center mb-5 mt-10"
																					style={{ height: "90vh" }}
																				>
																					<label>No Data Available!</label>
																				</div>
																				))}
																				*/}
                          {/* {isTableDataLoading ? (
																					<div
																						className="loading-container"
																						style={{
																							display: "flex",
																							alignItems: "center",
																							justifyContent: "center",
																							width: "75vw",
																							height: "90vh",
																						}}
																					>
																						<Spinner animation="border" role="status">
																							<span className="sr-only">Loading...</span>
																						</Spinner>
																					</div>
																				) : (summary_data_person_week.length > 0 ? (
																				<div style={{ width: "80vw", height: "90vh", overflow: "auto" }}>
																					<Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 2 }}>
																						Summary by person weekly
																					</Typography>
																					<Table>
																					<TableHead>
																						<TableRow>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("month")}
																						>
																							Month{" "}
																							{this.state.sort_column === "month" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("grade_id")}
																						>
																							Year{" "}
																							{this.state.sort_column === "year" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("language_id")}
																						>
																							Week{" "}
																							{this.state.sort_column === "week" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("language_id")}
																						>
																							First Name{" "}
																							{this.state.sort_column === "first_name" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("subject_id")}
																						>
																							Last Name{" "}
																							{this.state.sort_column === "last_name" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						<TableCell
																							className="thead"
																							style={{ cursor: "pointer", border: "1px solid black" }}
																							onClick={() => this.handleSortChange("subject_id")}
																						>
																							Total Questions{" "}
																							{this.state.sort_column === "total_questions" && (
																							<span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
																							)}
																						</TableCell>
																						</TableRow>
																					</TableHead>

																					<TableBody>
																						{summary_data_person_week.map((recordItem) => (
																						<TableRow key={recordItem.month}>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.month}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.year}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.week}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.first_name}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.last_name}
																							</TableCell>
																							<TableCell className="tData" style={{ border: "1px solid black" }}>
																								{recordItem.total_questions}
																							</TableCell>
																						</TableRow>
																						))}
																					</TableBody>
																					</Table>
																					<MaterialCustomTablePagination
																						totalCount = {total_summary_data_person_week}
																						currentPage = {currentPage}
																						limit = {limit}
																						handlePageChange = {this.handlePageChange}
																						handleRowsPerPageChange = {this.handleRowsPerPageChange}
																						handlePageOffsetChange = {this.handlePageOffsetChange}
																						offset = {this.state.offset}
																						rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 300]}
																					/>
																				</div>
																				) : (
																				<div
																					className="text-center mb-5 mt-10"
																					style={{ height: "90vh" }}
																				>
																					<label>No Data Available!</label>
																				</div>
																				))} */}

						</>
                     </div> 
					  
                    </div>
                  </div>
                </div>
              </>
            </CardBody>
          </Card>
        </ContentWrapper>
      </AdminTemplate>
    );
  }
}

export default QuestionSearch;
